import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "pageloader" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/static/img/AxisLoader.gif",
    alt: "Loading"
  })
], -1)
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "/static/img/simnach_logo.png",
  height: "300",
  width: "700",
  class: "rounded",
  alt: "..."
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { style: {"height":"70px"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "login-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/static/img/axis_logo.png",
    alt: "Axis Logo"
  })
], -1)
const _hoisted_8 = {
  class: "navbar fixed-top navbar-toggleable-md navbar-expand-lg double-nav",
  style: {"height":"60px"}
}
const _hoisted_9 = {
  class: "nav navbar-nav nav-flex-icons mr-auto",
  style: {"margin-left":"200px"}
}
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-left pl-2" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-link",
    href: "/home"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-home" })
  ])
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "breadcrumb-dn mr-auto" }, null, -1)
const _hoisted_15 = { class: "nav navbar-nav nav-flex-icons ml-auto" }
const _hoisted_16 = ["id"]
const _hoisted_17 = ["aria-labelledby"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "nav-item dropdown" }
const _hoisted_20 = {
  class: "nav-link dropdown-toggle",
  href: "#",
  id: "navbarDropdownMenuLink",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false",
  style: {"padding-bottom":"0px!important"}
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-user" }, null, -1)
const _hoisted_22 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "navbarDropdownMenuLink",
  style: {"min-width":"280px","padding":"4px 16px","font-size":"0.8em","line-height":"1.6","white-space":"nowrap"}
}
const _hoisted_23 = { style: {"padding":"4px 16px","font-size":"1em","line-height":"1.6"} }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold","margin-right":"4px"} }, "Last Login:", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold","margin-right":"4px"} }, "Unsuccessful Login:", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-sign-out-alt" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (!_ctx.isAuthenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createElementBlock("header", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("nav", _hoisted_8, [
              _createElementVNode("ul", _hoisted_9, [
                _createElementVNode("li", _hoisted_10, [
                  _createElementVNode("a", {
                    class: "nav-link",
                    href: "#",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)), ["prevent"]))
                  }, _hoisted_12)
                ]),
                _hoisted_13
              ]),
              _hoisted_14,
              _createElementVNode("ul", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userRoles, (role) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: role.id
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(role.menus, (menu) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: menu.id,
                        class: "nav-item dropdown"
                      }, [
                        _createElementVNode("a", {
                          class: "nav-link dropdown-toggle",
                          href: "#",
                          id: 'dropdown' + menu.role_id,
                          "data-toggle": "dropdown",
                          "aria-haspopup": "true",
                          "aria-expanded": "false"
                        }, _toDisplayString(menu.name), 9, _hoisted_16),
                        _createElementVNode("div", {
                          class: "dropdown-menu dropdown-menu-right",
                          "aria-labelledby": 'dropdown' + menu.role_id
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.submenus, (submenu) => {
                            return (_openBlock(), _createElementBlock("a", {
                              key: submenu.id,
                              class: "dropdown-item",
                              onClick: ($event: any) => (_ctx.navigateTo(submenu.access_path))
                            }, _toDisplayString(submenu.name), 9, _hoisted_18))
                          }), 128))
                        ], 8, _hoisted_17)
                      ]))
                    }), 128))
                  ], 64))
                }), 128)),
                _createElementVNode("li", _hoisted_19, [
                  _createElementVNode("a", _hoisted_20, [
                    _hoisted_21,
                    _createTextVNode(" " + _toDisplayString(_ctx.userName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", null, [
                        _hoisted_24,
                        _createElementVNode("span", null, _toDisplayString(_ctx.lastLoginTime), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_25,
                        _createElementVNode("span", null, _toDisplayString(_ctx.unsuccessfulLoginTime), 1)
                      ])
                    ]),
                    _hoisted_26,
                    _createElementVNode("a", {
                      class: "dropdown-item text-danger",
                      href: "#",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args)), ["prevent"]))
                    }, [
                      _hoisted_27,
                      _createTextVNode(" Logout ")
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}